import { updateFollowingPayDateFormGroupForPayFrequency } from "../local-site/form-functions";

window.sortCodeComponent = function () {
    return {
        valueOne: null,
        valueTwo: null,
        valueThree: null,
        partOne: null,
        partTwo: null,
        partThree: null,
        sortcode() {
            return this.valueOne + this.valueTwo + this.valueThree;
        },
        init() {
            this.partOne = this.$el.querySelector('[name=sortcode_one]');
            this.partTwo = this.$el.querySelector('[name=sortcode_two]');
            this.partThree = this.$el.querySelector('[name=sortcode_three]');
        },
        keyupHandler(event, part) {
            if (part === 1 && event.target.value.toString().length === 2) {
                this.partTwo.focus();
            }
            if (part === 2 && event.target.value.toString().length === 2) {
                this.partThree.focus();
            }
        },
        keydownHandler(event, part) {
            // Use this to restrict input to just numbers
            if (
                event.which <= 57 || // Digits
                event.which >= 96 && event.which <= 105 // Numpad Digits
                ) {
                // All good
            } else {
                event.preventDefault();
            }
        }
    }
};